// customIcons.tsx
import React from 'react';

export const CustomIcons: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  Compostable: (props) => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(0 0 0)"
      {...props}
    >
      <path
        d="M14.864 2.12882C14.9095 2.10698 14.9465 2.09012 14.9736 2.07812L15.0239 2.05611C15.2063 1.9813 15.4108 1.9813 15.5932 2.05611L15.6437 2.07812C15.6708 2.09012 15.7078 2.10698 15.7533 2.12882C15.8441 2.17245 15.9696 2.23631 16.1181 2.32148C16.4136 2.49096 16.8088 2.74953 17.2066 3.10758C18.0015 3.82292 18.8512 4.9805 18.8512 6.63136C18.8512 8.65152 17.3153 10.3833 15.3086 10.3833C13.302 10.3833 11.7661 8.65152 11.7661 6.63136C11.7661 4.9805 12.6158 3.82292 13.4107 3.10758C13.8085 2.74953 14.2037 2.49096 14.4992 2.32148C14.6477 2.23631 14.7731 2.17245 14.864 2.12882ZM16.2032 4.22253C15.9029 3.95226 15.5999 3.75348 15.3719 3.62269C15.35 3.61015 15.3289 3.59828 15.3086 3.58708C15.2884 3.59828 15.2673 3.61015 15.2454 3.62269C15.0174 3.75348 14.7144 3.95226 14.4141 4.22253C13.8127 4.76382 13.2661 5.54675 13.2661 6.63136C13.2661 7.61379 13.8207 8.40106 14.5586 8.72433V6.10612C14.5586 5.69191 14.8944 5.35612 15.3086 5.35612C15.7229 5.35612 16.0586 5.69191 16.0586 6.10612V8.72433C16.7966 8.40106 17.3512 7.61379 17.3512 6.63136C17.3512 5.54675 16.8046 4.76382 16.2032 4.22253Z"
        fill="#343C54"
      />
      <path
        opacity="0.4"
        d="M19.4266 11.0829C20.0839 10.5499 21.0447 10.6301 21.6044 11.2649C22.1114 11.84 22.1317 12.6964 21.6525 13.2949L17.7859 18.1236C17.4104 18.5924 16.8423 18.8653 16.2417 18.8653H10.0685C9.8825 18.8653 9.70317 18.9344 9.56527 19.0592L9.04042 19.534C9.14503 19.8626 9.01125 20.231 8.7004 20.4105L6.1238 21.8981C5.76508 22.1052 5.30638 21.9823 5.09928 21.6236L2.10061 16.4297C1.8935 16.071 2.01641 15.6123 2.37513 15.4052L4.95173 13.9176C5.18986 13.7801 5.47206 13.788 5.69546 13.9139L7.38764 12.5611C7.94114 12.1187 8.64057 11.8137 9.41278 11.8102C10.2262 11.8065 11.5119 11.8785 12.6754 12.3031H15.2732C15.9345 12.3031 16.512 12.6622 16.8212 13.1961L19.4266 11.0829ZM8.55886 17.9469C8.97255 17.5726 9.51056 17.3653 10.0685 17.3653H16.2417C16.3869 17.3653 16.5242 17.2993 16.615 17.186L20.4816 12.3573C20.5053 12.3277 20.5043 12.2854 20.4792 12.2569C20.4515 12.2255 20.404 12.2216 20.3715 12.2479L16.5205 15.3713C16.1984 15.6851 15.7583 15.8784 15.2732 15.8784H12.5383C12.1241 15.8784 11.7883 15.5426 11.7883 15.1284C11.7883 14.7142 12.1241 14.3784 12.5383 14.3784H15.2732C15.3195 14.3784 15.3633 14.3674 15.4021 14.3479C15.4102 14.3408 15.4184 14.3338 15.4269 14.3269L15.5 14.2677C15.5381 14.2189 15.5608 14.1575 15.5608 14.0907C15.5608 13.9319 15.432 13.8031 15.2732 13.8031H12.5912C12.4613 13.8031 12.3365 13.7785 12.222 13.7349C11.296 13.382 10.1887 13.3067 9.41955 13.3102C9.04628 13.3118 8.66549 13.46 8.32425 13.7328L6.53627 15.1621L8.2864 18.1934L8.55886 17.9469ZM3.77464 16.3292L6.02332 20.224L7.30088 19.4864L5.05221 15.5916L3.77464 16.3292Z"
        fill="#343C54"
      />
    </svg>
  ),

  X: (props) => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(0 0 0)"
      {...props}
    >
      <path
        d="M17.7512 2.96094H20.818L14.1179 10.6187L22 21.0391H15.8284L10.9946 14.7191L5.4636 21.0391H2.39492L9.56132 12.8483L2 2.96094H8.32824L12.6976 8.73762L17.7512 2.96094ZM16.6748 19.2035H18.3742L7.40492 4.70014H5.58132L16.6748 19.2035Z"
        fill="#343C54"
      />
    </svg>
  ),

  FoodSafe: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(0 0 0)"
    >
      <path
        opacity="0.4"
        d="M11.856 4.5C11.5408 4.5 11.2593 4.69709 11.1514 4.99326L10.5796 6.5625H15.027C15.2387 6.5625 15.4405 6.65196 15.5827 6.80879C15.7249 6.96563 15.7941 7.17525 15.7734 7.38592L15.3503 11.6875H12.9189C10.8479 11.6875 9.16895 13.3664 9.16895 15.4375V15.6179C8.75594 16.0258 8.5 16.5924 8.5 17.2188C8.5 17.8451 8.75594 18.4117 9.16895 18.8196V20.4976C9.16895 20.7621 9.21459 21.0159 9.29844 21.2517H6.657C5.49966 21.2517 4.53109 20.3737 4.4178 19.2219L3.25361 7.38592C3.23288 7.17525 3.30215 6.96563 3.44432 6.80879C3.58649 6.65196 3.78832 6.5625 4 6.5625H8.9832L9.74198 4.47979C10.0657 3.59128 10.9104 3 11.856 3H14.2655C14.6798 3 15.0155 3.33579 15.0155 3.75C15.0155 4.16421 14.6798 4.5 14.2655 4.5H11.856Z"
        fill="#343C54"
      />
      <path
        d="M10.6689 15.4387C10.6689 14.1961 11.6763 13.1887 12.9189 13.1887H17.8291C19.0717 13.1887 20.0791 14.1961 20.0791 15.4387V15.4698C20.0529 15.4686 20.0265 15.468 20 15.468H10.75C10.7228 15.468 10.6958 15.4686 10.6689 15.4699V15.4387Z"
        fill="#343C54"
      />
      <path
        d="M10.6689 18.9662V20.4988C10.6689 20.913 11.0047 21.2488 11.4189 21.2488H19.3291C19.7433 21.2488 20.0791 20.913 20.0791 20.4988V18.9663C20.0529 18.9674 20.0265 18.968 20 18.968H16.3943L15.9069 19.4554C15.2238 20.1385 14.1163 20.1388 13.4328 19.4561L12.9442 18.968H10.75C10.7228 18.968 10.6958 18.9674 10.6689 18.9662Z"
        fill="#343C54"
      />
      <path
        d="M10 17.218C10 16.8038 10.3358 16.468 10.75 16.468H20C20.4142 16.468 20.75 16.8038 20.75 17.218C20.75 17.6322 20.4142 17.968 20 17.968H15.9801L15.1998 18.7483C14.9071 19.0411 14.4324 19.0412 14.1395 18.7486L13.358 17.968H10.75C10.3358 17.968 10 17.6322 10 17.218Z"
        fill="#343C54"
      />
    </svg>
  ),

  NaturalMaterials: () => (
    <svg
      width="80"
      height="80"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(0 0 0)"
    >
      <path
        d="M11.9395 7.25C11.9395 5.45507 10.4844 4 8.68945 4C6.89453 4 5.43945 5.45507 5.43945 7.25C5.43945 8.09329 5.7594 8.86042 6.28613 9.43848C6.54624 9.724 6.54532 10.156 6.29492 10.4395L6.24121 10.4941C5.52742 11.1541 5.08203 12.0963 5.08203 13.1436C5.08216 14.8784 6.30734 16.3257 7.93945 16.6709V14.5C7.93945 14.0858 8.27524 13.75 8.68945 13.75C9.10367 13.75 9.43945 14.0858 9.43945 14.5V16.6709C11.0713 16.3255 12.2958 14.8782 12.2959 13.1436C12.2959 12.0965 11.8513 11.1541 11.1377 10.4941C10.8351 10.2144 10.8152 9.74305 11.0928 9.43848C11.6195 8.86041 11.9395 8.09333 11.9395 7.25ZM13.4395 7.25C13.4395 8.23055 13.1402 9.14163 12.6309 9.89844C13.3576 10.7805 13.7959 11.9109 13.7959 13.1436C13.7958 15.7091 11.9042 17.8314 9.43945 18.1943V20.75C9.43945 21.1642 9.10367 21.5 8.68945 21.5C8.27524 21.5 7.93945 21.1642 7.93945 20.75V18.1943C5.47447 17.8316 3.58217 15.7093 3.58203 13.1436C3.58203 11.9107 4.02015 10.7795 4.74707 9.89746C4.23818 9.14088 3.93945 8.23006 3.93945 7.25C3.93945 4.62665 6.0661 2.5 8.68945 2.5C11.3128 2.5 13.4395 4.62665 13.4395 7.25Z"
        fill="#343C54"
      />
      <path
        opacity="0.4"
        d="M16.3564 5.89062C18.599 5.89062 20.417 7.70862 20.417 9.95117C20.417 10.8866 20.0985 11.7474 19.5674 12.4336C20.0987 13.1199 20.417 13.9813 20.417 14.917C20.4169 16.9031 18.9905 18.5542 17.1064 18.9062V20.75C17.1064 21.1642 16.7707 21.5 16.3564 21.5C15.9422 21.5 15.6064 21.1642 15.6064 20.75V18.9062C14.2315 18.6494 13.1008 17.7005 12.5898 16.4346C13.3406 15.5458 13.7949 14.3984 13.7949 13.1436C13.7949 11.9109 13.3566 10.7805 12.6299 9.89844C13.1392 9.14163 13.4385 8.23054 13.4385 7.25C13.4385 7.21049 13.4365 7.17112 13.4355 7.13184C14.174 6.36697 15.2093 5.89064 16.3564 5.89062ZM16.3564 7.39062C14.9423 7.39065 13.7959 8.53707 13.7959 9.95117C13.7959 10.7158 14.1303 11.4018 14.6631 11.8721C14.8241 12.0144 14.9169 12.2187 14.917 12.4336C14.917 12.6487 14.8243 12.8537 14.6631 12.9961C14.1302 13.4664 13.7959 14.1523 13.7959 14.917C13.796 16.0701 14.5584 17.0446 15.6064 17.3652V15.25C15.6064 14.8358 15.9422 14.5 16.3564 14.5C16.7707 14.5 17.1064 14.8358 17.1064 15.25V17.3652C18.1545 17.0446 18.9169 16.07 18.917 14.917C18.917 14.1524 18.5826 13.4664 18.0498 12.9961C17.8886 12.8537 17.7959 12.6487 17.7959 12.4336C17.796 12.2187 17.8887 12.0143 18.0498 11.8721C18.5826 11.4018 18.917 10.7158 18.917 9.95117C18.917 8.53705 17.7706 7.39062 16.3564 7.39062Z"
        fill="#343C54"
      />
    </svg>
  ),

  WorldwideShipping: (props) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.5 3 2.5 15 0 18" />
    </svg>
  ),

  ExportSupply: (props) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 20h16V10H4v10z" />
      <path d="M12 4v8" />
      <path d="M8 8l4-4 4 4" />
    </svg>
  ),

  ConsistentQuality: (props) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12 2l3 2 4 .5-1 3.5 1 3.5-4 .5-3 2-3-2-4-.5 1-3.5-1-3.5 4-.5 3-2z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),

  ReliableScalable: (props) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 20V10" />
      <path d="M10 20V6" />
      <path d="M16 20V4" />
      <path d="M4 20h16" />
    </svg>
  ),

  Documentation: (props) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M6 2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
      <path d="M14 2v5h5" />
      <path d="M9 14l2 2 4-4" />
    </svg>
  ),
  Youtube: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.5806 7.19355C21.3548 6.32258 20.6774 5.64516 19.8065 5.41935C18.2581 5 12 5 12 5C12 5 5.74194 5 4.19355 5.41935C3.32258 5.64516 2.64516 6.32258 2.41935 7.19355C2 8.77419 2 12 2 12C2 12 2 15.2581 2.41935 16.8065C2.64516 17.6774 3.32258 18.3548 4.19355 18.5806C5.74194 19 12 19 12 19C12 19 18.2581 19 19.8065 18.5806C20.6774 18.3548 21.3548 17.6774 21.5806 16.8065C22 15.2581 22 12 22 12C22 12 22 8.77419 21.5806 7.19355ZM10 15V9L15.1935 12L10 15Z"
        fill="#FF0000"
      />
    </svg>
  ),
  Facebook: (props) => (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2.53906C17.5229 2.53906 22 7.01621 22 12.5391C22 17.5304 18.3431 21.6674 13.5625 22.4176V15.4297H15.8926L16.3359 12.5391L13.5625 12.5387V10.6632C13.5625 10.657 13.5625 10.6509 13.5626 10.6447C13.5626 10.6354 13.5628 10.6262 13.5629 10.6169C13.578 9.84259 13.9742 9.10156 15.1921 9.10156H16.4531V6.64062C16.4531 6.64062 15.3087 6.44492 14.2146 6.44492C11.966 6.44492 10.4842 7.78652 10.4386 10.2193C10.4379 10.2578 10.4375 10.2965 10.4375 10.3355V12.5387H7.89844V15.4293L10.4375 15.4297V22.4172C5.65686 21.667 2 17.5304 2 12.5391C2 7.01621 6.47715 2.53906 12 2.53906Z"
        fill="#1877F2"
      />
    </svg>
  ),
  Instagram: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 2C4.243 2 2 4.243 2 7v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V7c0-2.757-2.243-5-5-5H7zm10 2c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3V7c0-1.654 1.346-3 3-3h10zm-5 3a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm4.5-3a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0116.5 6z"
        fill="#E4405F"
      />
    </svg>
  ),
  LinkedIn: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.98 3.5C4.98 4.88 3.88 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1 4.98 2.12 4.98 3.5zM.5 8h4v14h-4V8zm7.5 0h3.8v2.2h.1c.5-1 1.8-2.2 3.8-2.2 4 0 4.7 2.6 4.7 6V22h-4v-8.3c0-2-.1-4.6-2.8-4.6-2.8 0-3.2 2.2-3.2 4.4V22h-4V8z"
        fill="#0A66C2"
      />
    </svg>
  ),
  Twitter: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.748l7.73-8.835L1.254 2.25H8.08l4.713 6.231z"
        fill="#000000"
      />
    </svg>
  ),
  AIChatbot: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2C6.48 2 2 5.58 2 10c0 2.38 1.34 4.5 3.44 5.92L4.5 22l5.2-3.12c.76.18 1.56.28 2.3.28 5.52 0 10-3.58 10-8s-4.48-9-10-9z"
        fill="#7CB342"
      />
      <circle cx="9" cy="11" r="1.5" fill="white" />
      <circle cx="15" cy="11" r="1.5" fill="white" />
    </svg>
  ),
  WhatsApp: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* currentColor, not the brand #25D366 literal: on a light surface that
          green measures 1.98:1 against white, and an icon-only WhatsApp button
          has no text label, so the glyph is the only thing identifying the
          control (WCAG 2.1 SC 1.4.11 needs 3:1). Call sites pick the tone -
          #25D366 on dark surfaces, the darker #128C7E on light ones. */}
      <path
        d="M12 2C6.48 2 2 6.24 2 11.5c0 2.3.88 4.4 2.34 6.06L3 22l4.7-1.22A10.3 10.3 0 0012 21c5.52 0 10-4.24 10-9.5S17.52 2 12 2z"
        fill="currentColor"
      />
      <path
        d="M16.2 14.3c-.2-.1-1.2-.6-1.4-.7-.2-.1-.4-.1-.6.1-.2.3-.7.8-.9 1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.8-1.6-2.1-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.4.1-.1.2-.2.3-.4.1-.2.1-.3 0-.5-.1-.1-.6-1.4-.8-1.9-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.2-1 1-1 2.4 0 1.4 1 2.7 1.2 2.9.2.3 2 3.1 5 4.2.7.3 1.3.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.2-.5 1.4-1 .2-.5.2-.9.2-1 0-.1-.2-.2-.4-.3z"
        fill="white"
      />
    </svg>
  ),
  Location: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
        fill="#FF3B30"
      />
      <circle cx="12" cy="9" r="3" fill="white" />
    </svg>
  ),
  Mail: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 5h18c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"
        fill="#0078FF"
      />
      <path
        d="M3 7l9 6 9-6"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Phone: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.6 2h2.8c.5 0 .9.3 1 .8l.6 3c.1.4 0 .8-.3 1.1l-1.6 1.6c1 2.2 2.8 4 5 5l1.6-1.6c.3-.3.7-.4 1.1-.3l3 0.6c.5.1.8.5.8 1v2.8c0 .6-.4 1-1 1C12.4 22 2 11.6 2 3c0-.6.4-1 1-1z"
        fill="#34C759"
      />
    </svg>
  ),

  // ── Tableware product-type icons (line-art, inherit currentColor) ──────────
  PlateIcon: (props) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="4.5" />
    </svg>
  ),
  BowlIcon: (props) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M3 10.5h18" />
      <path d="M4.5 10.5a7.5 7.5 0 0 0 15 0" />
      <path d="M14 4.5c.8.6 1 1.6.5 2.5M10.5 4c.8.6 1 1.6.5 2.5" />
    </svg>
  ),
  TrayIcon: (props) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <path d="M12 6v12" />
      <path d="M3 12h9" />
    </svg>
  ),
  CupIcon: (props) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M7 8h10l-1 11a2 2 0 0 1-2 1.8h-4a2 2 0 0 1-2-1.8L7 8z" />
      <path d="M17 10.5h2a2 2 0 0 1 0 4h-1.5" />
      <path d="M9 4.5l-.5 3.5M15 4.5l.5 3.5" />
    </svg>
  ),
  CutleryIcon: (props) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M8 3v6a2 2 0 0 1-4 0V3" />
      <path d="M6 9v12" />
      <path d="M16 21V3c-2 0-3 2.2-3 5s1 4 3 4" />
    </svg>
  ),
};
